import { IconButton } from "@mui/material";

export const MuiIconButton = IconButton;
